import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import WidgetCard from './WidgetCard'

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Row = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background: ${(p) =>
    p.$done ? p.theme?.color?.accentSoft || '#E1ECE7' : p.theme?.color?.bgSubtle || '#F4F0E9'};
`

const Check = styled.button`
  appearance: none;
  border: 2px solid ${(p) => p.theme?.color?.borderStrong || '#D5CCBC'};
  background: ${(p) => (p.$on ? p.theme?.color?.accent || '#6B9080' : 'transparent')};
  width: 28px;
  height: 28px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
`

const Body = styled.div`
  flex: 1;
  min-width: 0;
`
const Title = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
  text-decoration: ${(p) => (p.$done ? 'line-through' : 'none')};
  text-decoration-color: rgba(31, 41, 55, 0.4);
`

const Sub = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
`

const keyForActivity = (id) =>
  id === 'act_journal'
    ? 'act_journal_done'
    : id === 'act_walk'
    ? 'act_walk_done'
    : id === 'act_physio'
    ? 'act_physio_done'
    : null

export default function ActivitiesTodayCard({ data, onComplete }) {
  const navigate = useNavigate()
  if (!data || data.length === 0) return null

  const doneCount = data.filter((a) => a.completed).length

  return (
    <WidgetCard
      title="Activities today"
      badge={doneCount === data.length ? 'All done' : `${doneCount}/${data.length}`}
    >
      <List>
        {data.map((a) => {
          const k = keyForActivity(a.activityId)
          return (
            <Row key={a.activityId} $done={a.completed}>
              <Check
                $on={a.completed}
                aria-label={a.completed ? `${a.title} completed` : `Mark ${a.title} done`}
                onClick={() => k && !a.completed && onComplete && onComplete(k)}
              >
                {a.completed ? '✓' : ''}
              </Check>
              <Body>
                <Title $done={a.completed}>{a.title}</Title>
                <Sub>
                  {a.practitionerName}
                  {a.estimatedDurationLabel ? ` · ${a.estimatedDurationLabel}` : ''}
                </Sub>
              </Body>
            </Row>
          )
        })}
      </List>
      <button
        onClick={() => navigate('/patient-home/care/activities')}
        style={{
          marginTop: 14,
          background: 'transparent',
          border: 'none',
          color: '#1F3A5F',
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: 'pointer',
          padding: 0,
          fontSize: 14,
        }}
      >
        See all activities →
      </button>
    </WidgetCard>
  )
}
